import React from 'react';
import styled from 'styled-components';
import media, { sizes } from 'components/media/media';
import NavBarItem from './NavBarItem';

const hamburger = require('assets/primary-interface/poop/navbar/hamburger.svg');

const NAVBAR_HEIGHT = '72px';
export const MOBILE_NAVBAR_HEIGHT = '56px';

const Slider = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  overflow-x: hidden;
  background-color: #303030;
`;

const Cover = styled.div`
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  transition: all 0.3s linear;

  pointer-events: ${({ expanded }) => expanded ? 'auto' : 'none'};

  background-color: ${({ expanded }) => expanded ? 'rgba(0,0,0,0.4)' : 'transparent'}
`;

const Container = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  user-select: none;
  overflow: visible;
  max-width: 100vw;
  visibility: visible;

  transition: transform 0.3s ease-in-out;

  transform: translateX(${({ expanded }) => expanded ? '250px' : 0});
  box-shadow: ${({ expanded }) => expanded ? '0px 0px 20px 3px #232323' : 'none'};
`;

const Bar = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #303030;

  height: ${NAVBAR_HEIGHT};
  ${media.portrait`
    height: ${MOBILE_NAVBAR_HEIGHT};
    padding: 8px;
  `}
  width: 100%;
`;

const Items = styled.div`
  height: 100%;
  display: flex;
`;

const Children = styled.div`
  position: absolute;
  top: ${NAVBAR_HEIGHT};
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 100vw;
  ${media.portrait`
    top: ${MOBILE_NAVBAR_HEIGHT};
  `}
`;

const SliderItems = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 250px;
  overflow-y: auto;
  visibility: ${({ expanded }) => expanded ? 'visible' : 'hidden'};
`;

const mediaQueries = {
  isLandscape: matchMedia(`(max-width: ${sizes.landscape}px)`),
  isPortrait: matchMedia(`(max-width: ${sizes.portrait}px)`),
  isMobile: matchMedia(`(max-width: ${sizes.mobile}px)`),
};

const getMode = () => {
  if (mediaQueries.isMobile.matches) {
    return 'mobile';
  } else if (mediaQueries.isPortrait.matches) {
    return 'portrait';
  } else if (mediaQueries.isLandscape.matches) {
    return 'landscape';
  } else {
    return 'desktop';
  }
};

export default class NavBar extends React.Component {
  constructor() {
    super();

    this.state = {
      mode: getMode(),
      expanded: false
    };
  }
  componentWillMount() {
    Object.keys(mediaQueries).forEach(k => {
      mediaQueries[k].addListener(this.handleMediaChange);
    });
  }
  componentWillUnmount() {
    Object.keys(mediaQueries).forEach(k => {
      mediaQueries[k].removeListener(this.handleMediaChange);
    });
  }
  handleMediaChange = () => {
    const mode = getMode();
    if (mode === 'landscape' || mode === 'desktop') {
      this.setState({ expanded: false });
    }
    this.setState({ mode });
  };
  toggleExpand = () => {
    this.setState({ expanded: !this.state.expanded });
  };
  handleCollapse = (e) => {
    if (this.state.expanded) {
      e.preventDefault();
      e.stopPropagation();
      this.setState({ expanded: false });
    }
  };
  evaluateItem = (expanderItems) => (item, i) => {
    const toRemove = [];

    if (mediaQueries.isLandscape.matches) { toRemove.push('landscape'); }
    if (mediaQueries.isPortrait.matches) { toRemove.push('portrait'); }
    if (mediaQueries.isMobile.matches) { toRemove.push('mobile'); }

    if (toRemove.indexOf(item.props.collapse) !== -1) {
      if (item.props.items) {
        item.props.items.forEach((item, j) => {
          expanderItems.push((
            <NavBarItem
              side={true}
              key={item.title || item.icon}
              icon={item.icon}
              to={item.to}
              onClick={item.onClick}
              title={item.title}
              className={item.className}
              tourExpanded={item.tourExpanded}
            />
          ));
        });
      } else {
        expanderItems.push((
          <NavBarItem {...item.props} key={item.props.title || item.props.icon}
            title={item.props.title || item.props.collapsedTitle}
            side={true}
          />
        ));
      }
      return null;
    }

    return item;
  };
  render() {
    const expanded = this.props.tourExpanded == null ? this.state.expanded : this.props.tourExpanded;

    let expanderItems = [];

    const left = React.Children.map(this.props.left, this.evaluateItem(expanderItems));
    const right = React.Children.map(this.props.right, this.evaluateItem(expanderItems));

    return (
      <Slider>
        <SliderItems onClick={this.handleCollapse} expanded={expanded}>
          {expanderItems}
        </SliderItems>
        <Container expanded={expanded} className="stuff">
          <Bar>
            <Items>
              {expanderItems.length ? (<NavBarItem id="navbar-menu" icon={hamburger} onClick={this.toggleExpand} />) : null}
              {left}
            </Items>
            {this.props.centreDisplay && 
              <Items>
                <NavBarItem title={this.props.centreDisplay} displayOnly />
              </Items>
            }
            <Items>
              {right}
            </Items>
          </Bar>
          <Children>
            {this.props.children}
          </Children>
          <Cover id="cover" onClick={this.handleCollapse} expanded={expanded} />
        </Container>
      </Slider>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js